import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Collapse,
  IconButton,
  Typography,
} from "@mui/material";
import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import moment from "moment";

function ConnectedCallTable({ callData }) {
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page
  const [openRows, setOpenRows] = useState([]); // To manage which rows are expanded

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page
  };

  // Handle row expansion toggle
  const handleRowToggle = (index) => {
    setOpenRows((prev) => {
      if (prev.includes(index)) {
        return prev.filter((rowIndex) => rowIndex !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  const formatDate = (dateString) =>
    moment(dateString).format("DD-MM-YYYY HH:mm:ss");

  return (
    <>
      <Paper>
        <TableContainer component={Paper} elevation={3}>
          <Table
            sx={{
              minWidth: 650,
              height: "100%",
              tableLayout: "fixed",
            }}
            aria-label="simple table"
          >
            <TableHead>
              <TableRow sx={{ backgroundColor: "#EEF0F4" }}>
                <TableCell width={50} sx={{ textAlign: "center" }} />
                <TableCell
                  width={50}
                  sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
                >
                  SNo
                </TableCell>
                <TableCell
                  width={160}
                  sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
                >
                  Call Id
                </TableCell>
                <TableCell
                  width={150}
                  sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
                >
                  Caller Number
                </TableCell>
                <TableCell
                  width={150}
                  sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
                >
                  Connected At
                </TableCell>
                <TableCell
                  width={120}
                  sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
                >
                  Ended At
                </TableCell>
                <TableCell
                  width={120}
                  sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
                >
                  Duration (Minutes)
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {callData.length > 0 ? (
                callData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, rowIndex) => (
                    <React.Fragment key={rowIndex}>
                      <TableRow
                        sx={{
                          "&:hover": { backgroundColor: "#f9f9f9" },
                        }}
                      >
                        <TableCell>
                          <IconButton
                            onClick={() => handleRowToggle(rowIndex)}
                            sx={{ padding: 0 }}
                          >
                            <ExpandMoreIcon />
                          </IconButton>
                        </TableCell>
                        <TableCell width={50} sx={{ textAlign: "center" }}>
                          {page * rowsPerPage + rowIndex + 1}
                        </TableCell>
                        <TableCell width={160} sx={{ textAlign: "center" }}>
                          {row.call_id || "-"}
                        </TableCell>
                        <TableCell width={150} sx={{ textAlign: "center" }}>
                          {row.customer_number || "-"}
                        </TableCell>
                        <TableCell width={150} sx={{ textAlign: "center" }}>
                          {row.connected_at || "-"}
                        </TableCell>
                        <TableCell width={120} sx={{ textAlign: "center" }}>
                          {row.ended_at || "-"}
                        </TableCell>
                        <TableCell
                          width={120}
                          sx={{
                            textAlign: "center",
                            textTransform: "capitalize",
                          }}
                        >
                          {row.duration_minutes || "-"}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          colSpan={7}
                          sx={{ paddingBottom: 0, paddingTop: 0 }}
                        >
                          <Collapse
                            in={openRows.includes(rowIndex)}
                            timeout="auto"
                            unmountOnExit
                          >
                            <Paper sx={{ padding: 2 }}>
                              <Typography variant="h6">
                                Customer Details
                              </Typography>
                              <Typography>
                                <strong>Farmer Name:</strong>{" "}
                                {row.customer_details?.farmer_name || "-"}
                              </Typography>
                              <Typography>
                                <strong>Lot Number:</strong>{" "}
                                {row.customer_details?.lot_number || "-"}
                              </Typography>
                              <Typography>
                                <strong>Zone:</strong>{" "}
                                {row.customer_details?.zone || "-"}
                              </Typography>
                              <Typography>
                                <strong>Branch:</strong>{" "}
                                {row.customer_details?.branch || "-"}
                              </Typography>
                              <Typography>
                                <strong>Hatch Date:</strong>{" "}
                                {row.customer_details?.hatch_date || "-"}
                              </Typography>
                              <Typography>
                                <strong>Placed Quantity:</strong>{" "}
                                {row.customer_details?.placed_qty || "-"}
                              </Typography>
                              <Typography>
                                <strong>Shed Type:</strong>{" "}
                                {row.customer_details?.shed_type || "-"}
                              </Typography>
                              <Typography>
                                <strong>Status:</strong>{" "}
                                {row.customer_details?.status || "-"}
                              </Typography>
                              <Typography>
                                <strong>Vendor:</strong>{" "}
                                {row.customer_details?.vendor || "-"}
                              </Typography>
                              <Typography>
                                <strong>Total Mortality:</strong>{" "}
                                {row.customer_details?.total_mortality || "-"}
                              </Typography>
                              <Typography>
                                <strong>Mortality Percentage:</strong>{" "}
                                {row.customer_details?.mortality_percentage ||
                                  "-"}
                              </Typography>
                            </Paper>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No details yet
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]} // Options for rows per page
          component="div"
          count={callData.length} // Total number of rows
          rowsPerPage={rowsPerPage} // Current rows per page
          page={page} // Current page
          onPageChange={handleChangePage} // Handle page change
          onRowsPerPageChange={handleChangeRowsPerPage} // Handle rows per page change
        />
      </Paper>
    </>
  );
}

export default ConnectedCallTable;
